import React from "react";
import { useTranslation } from "react-i18next";
import ScreenLayout from "../ui/ScreenLayout";
import Icon from "../ui/Icon";

// Écran 1c bis : attente de la réponse de la borne, avec le rappel du branchement.
// Sur mobile le rappel est en bas d'écran, en version web sous le texte.
export default function ChargeConnectingScreen({ panel }) {
  const { t } = useTranslation();

  return (
    <ScreenLayout panel={panel}>
      <div className="pt-16 flex flex-col items-center text-center md:pt-6" aria-live="polite">
        <div className="relative h-24 w-24" aria-hidden="true">
          <div className="absolute inset-0 rounded-full border-[6px] border-qv-brand-100" />
          <div className="absolute inset-0 rounded-full border-[6px] border-transparent border-t-qv-brand animate-spin" />
        </div>
        <h1 className="mt-8 mb-2 text-[28px] leading-9 tracking-[-.02em] font-bold md:text-[30px] md:leading-[38px]">
          {t("startCharging.connecting.title")}
        </h1>
        <p className="text-[15px] leading-6 text-qv-muted">{t("startCharging.connecting.text")}</p>
      </div>

      <div className="mt-auto pt-10 pb-4 md:mt-8 md:p-0">
        <div className="rounded-2xl bg-qv-brand-50 p-4 flex gap-3 items-start">
          <Icon name="plug-circle-linear" size={24} className="text-qv-brand" />
          <div className="flex flex-col gap-1">
            <span className="text-sm leading-5 font-bold">{t("startCharging.connecting.plugTitle")}</span>
            <span className="text-[13px] leading-[19px] font-medium text-qv-muted">
              {t("startCharging.connecting.plugText")}
            </span>
          </div>
        </div>
      </div>
    </ScreenLayout>
  );
}
